import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";


export default function CustomBlEtudiantV3({context,loading, campagneData})
{

    const screenOptions=campagneData?.screenOptions || {}

    useEffect(() => {
        document.body.style.overflow="hidden";
        document.body.style.cursor="none";
    }, []);

    if(loading)
    {
        return (
            <div className="screen" style={{aspectRatio: "16/9", position: "relative"}}>
                <div className={"screen-background"}>
                </div>
            </div>
        )
    }

    return (
        <div className="screen" style={{
            aspectRatio: "16/9",
            position: "relative",
            height:"100vh",
            width:"100vw",
            overflow:"hidden",
            backgroundColor:"#A63042"
        }}>

            {/* Cadre intérieur blanc */}
            <div style={{
                position:"absolute",
                top:"3vh",
                left:"2.2vw",
                right:"2.2vw",
                bottom:"3vh",
                backgroundColor:"#FFF",
                zIndex:1
            }}/>

            {/* Asset 13 = ornements rouges (cadre + motifs en arrière-plan) */}
            <img
                src={"/campagne/screen/custom-bl-etudiants-v3/Asset 13@4x.png"}
                style={{
                    position:"absolute",
                    top:0,
                    left:0,
                    width:"100vw",
                    height:"100vh",
                    pointerEvents:"none",
                    zIndex:2
                }}
            />

            {/* Contenu principal */}
            <div style={{
                position:"absolute",
                top:"3vh",
                left:"2.2vw",
                right:"2.2vw",
                bottom:"3vh",
                zIndex:3,
                display:"flex",
                flexDirection:"column",
                alignItems:"center"
            }}>

                {/* Header + bloc compteur (Asset 11) avec compteur superposé */}
                <div style={{
                    position:"relative",
                    marginTop:"5vh",
                    width:"55%",
                }}>
                    <img
                        src={"/campagne/screen/custom-bl-etudiants-v3/Asset 11@4x.png"}
                        style={{width:"100%", height:"auto", display:"block"}}
                    />
                    {/* Compteur dynamique superposé sur la zone dorée droite du bloc */}
                    <ScreenBarPartner context={context} campagneData={campagneData}/>
                </div>

                {/* Liste des derniers dons */}
                <div style={{marginTop:"6vh",width:"100%"}}>
                    <ScreenDonSection context={context} campagneData={campagneData}/>
                </div>

                {/* Spacer pour pousser la barre en bas */}
                <div style={{flex:1}}/>

                {/* Barre de progression en bas */}
                {!screenOptions.barMini && (
                    <ProgressFooter campagneData={campagneData}/>
                )}
            </div>

            {screenOptions.forceCelebration &&(
                <Fireworks
                    autostart
                    options={{intensity:30,particles:100,traceLength:1,opacity:0.2}}
                    style={{
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        position: 'fixed',
                        background: 'transparent',
                        zIndex: 10
                    }}
                />
            )}
        </div>
    )
}


function ProgressFooter({campagneData}){
    const partnerMontant=campagneData?.partnerMontant || 1
    const total=campagneData.stats.total.sum.total/partnerMontant

    const displayPercent=Math.min((Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0), 100)

    return (
        <div style={{
            width:"96.8%",
            height:"5.5vh",
            backgroundColor:"#F4EDDC",
            overflow:"hidden",
            position:"absolute",
            bottom:"3.5vh"
        }}>
            <div style={{
                height:"100%",
                width: displayPercent+"%",
                backgroundColor:"#B69E5C"
            }}/>
        </div>
    )
}
